import ChatMessageBubble from "./ChatMessageBubble";

export default ChatMessageBubble;
